import { render, staticRenderFns } from "./ProductSubCategoryList.vue?vue&type=template&id=7ca0b5b4&"
import script from "./ProductSubCategoryList.vue?vue&type=script&lang=js&"
export * from "./ProductSubCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports